module.exports = __webpack_public_path__ + "static/media/calendar.9ecdacef.svg";